import React from 'react';
import { Typography, Grid, Paper, Link } from '@mui/material';
import CustomerLayout from '../CustomerLayout'; // ✅ Adjusted path for layout


const CommunityForums = () => {
  return (
    <CustomerLayout>
    <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
      <Typography variant="h4" gutterBottom>Community Forums</Typography>

      <div style={{ marginBottom: '20px' }}></div> {/* Space between heading and content */}

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Paper elevation={2} style={{ padding: '20px', marginBottom: '20px' }}>
            <Typography variant="h5">General Discussions</Typography>
            <Typography>Join the conversation in our community forums.</Typography>
            {/* Add forum links here */}
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper elevation={2} style={{ padding: '20px', marginBottom: '20px' }}>
            <Typography variant="h5">Ask Questions</Typography>
            <Typography>Have a question? Ask the community for help.</Typography>
            {/* Add Q&A links here */}
          </Paper>
        </Grid>
      </Grid>
    </Paper>
  </CustomerLayout>
  );
};

export default CommunityForums;
